import { RailsProvider } from "../../../../src/components/rails-provider";
import { StatusTable } from "../../../../src/components/status";
import * as React from 'react';
export default {
  RailsProvider,
  StatusTable,
  React
};